import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    height: '100%',

    '& .MuiPaper-root': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  container: {
    width: 'calc(100% - 280px)',
    marginLeft: '256px',
    minHeight: 'calc(100vh - 64px)',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 'auto',
    },
  },
  
  pageTitle: {
    marginBottom: theme.spacing(2),
    color: 'rgba(51, 51, 51, 0.87)',
  },
}));


function VideoList(props) {
  const classes = useStyles();

  return (
      <Container className={classes.container} maxWidth="md">
        <Typography gutterBottom variant="h1" className={classes.pageTitle} component="h1">404</Typography>
        <Typography gutterBottom variant="h5" className={classes.pageSubTitle} component="h2">Такой страницы не существует</Typography>
        <Typography gutterBottom variant="h6" className={classes.pageSubTitle} component="h2">Перейдите на <Link to='/'>главную страницу</Link></Typography>
        <Grid container className={classes.root} spacing={3}>
          
        </Grid>
        
      </Container>
  );
}

export default VideoList;
